import { getStatistics, getEmailEventList, getTaskNameList } from '@/services/edm'

export default {
  namespaced: true,
  state: {
    taskNameList: [],
    statisticsData: {},
    listDatas: [],
    pagination: {
      currentPage: 1,
      pageSize: 10,
      pageSizes: ['10', '20', '30', '50'],
      total: 0
    },

    loading: true
  },
  mutations: {
    SET_STATISTICS_DATA (state, data) {
      // data.delivered = '23 (10%)'
      state.statisticsData = data
    },
    setListDatas (state, data) {
      state.listDatas = data
    },
    SET_LOADING (state, data) {
      state.loading = data
    },
    SET_TOTAL (state, data) {
      state.pagination.total = data
    },
    GET_TASK_NAME_LIST (state, data) {
      state.taskNameList = data
    }
  },
  actions: {
    async fetchStatistics ({ commit }, params) {
      let chain = await getStatistics()
      chain
        .params(params)
        .config({ tip: false, warn: false })
        .onSuccess(res => {
          commit('SET_STATISTICS_DATA', res)
        }).fetch()
      return chain
    },
    async fetchEmailEventList ({ commit }, params) {
      commit('SET_LOADING', true)
      let chain = await getEmailEventList()
      chain
        .params(params)
        .config({ tip: false })
        .onSuccess(res => {
          commit('setListDatas', res.list)
          commit('SET_LOADING', false)
          commit('SET_TOTAL', res.count)
        })
        .fetch()
      return chain
    },
    async fetchTaskNameList ({ commit }, params) {
      let chain = await getTaskNameList()
      chain
        .params(params)
        .config({ tip: false, warn: false })
        .onSuccess((res = []) => {
          commit('GET_TASK_NAME_LIST', res)
        })
        .fetch()
      return chain
    }
  }
}
